export default "__VITE_ASSET__DxaeUALq__"